//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "science",
    data() {
        return {
            // scienceKnowledge:[
            //     {
            //         title:'新房和二手房在收房方面的区别，需要注意哪些事项？',
            //         mark:'装修小知识',
            //         image:require('@/assets/img/sc-p1.png'),
            //         intro:'不管新房还是二手房，验收房屋都是十分关键的一个环节，千万不能马虎。新房和二手房在验收时有许多需要注意的地方……',
            //         name: '/scienceZx',
            //     },
            //     {
            //         title:'新房入住的交接流程，需要注意什么？',
            //         mark:'交房流程',
            //         image:require('@/assets/img/sc-p2.png'),
            //         intro:'按照我国法律规定，房屋的交付应以产权证的登记和取得为最终的交付。但在实际生活中，买卖双方一般是以入住交接作为房屋交付的一个标志。新房入住交接，自开发商通知收',
            //         name: '/scienceJq',
            //     },
            //     {
            //         title:'装修的5个套路陷阱',
            //         mark:'维修小百科',
            //         image:require('@/assets/img/sc-p3.jpg'),
            //         intro:'相信每个搞完装修的业主都有一把辛酸泪，谈单的时候各种装修公司给各种优惠，自认为赚了便宜，等把合同一签开始进场了，各种多花钱的地方就来了。俗话说“买的没有卖的.',
            //         name: '/scienceWx',
            //     },
            //     {
            //         title:'卫生间防水验收规范你知道吗',
            //         mark:'验房小百科',
            //         image:require('@/assets/img/sc-p4.png'),
            //         intro:'卫生间每天都与水打交道，也是我们日常进出频繁的重要区域，防水工作若是没做到位，那么极有可能为日后的生活留下隐患...',
            //         name: '/scienceYf',
            //     },
            //
            // ],
            list:[],
            id:'',
            downloadUrl: util.ApiUrl + '/file/download/',
        }
    },
    methods: {
        getContentByNodeName() {
            abp.ajax.get('/api/services/app/Content/GetAllContentByName?name=' + '验房百科').then((res) => {
                var list = res.data.result;
                if (list.length > 0) {
                    // console.log(list);
                    /*this.getGraphicInformationByBusiness(list[0].id)*/
                    this.list.push(...res.data.result);
                }
            });
        },
        getGraphicInformationByBusiness(id) {
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessId=' + id + '&businessType=content.remarks').then(res => {
                this.content = [];
                this.content = res.data.result;
                // console.log(res.data);
            })
        },
        listClicked(list) {
            this.$router.push('/serveMsgDetail/' + list.id);
        },
    },
    created() {
        this.getContentByNodeName();

    }
}
